import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sdash" }
const _hoisted_2 = { class: "sdash__hero" }
const _hoisted_3 = { class: "sdash__hero-copy" }
const _hoisted_4 = { class: "sdash__hero-eyebrow" }
const _hoisted_5 = { class: "sdash__hero-title" }
const _hoisted_6 = { class: "sdash__hero-desc" }
const _hoisted_7 = { class: "sdash__hero-actions" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  class: "sdash__notice-icon",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "sdash__kpi-label" }
const _hoisted_12 = { class: "sdash__kpi-value" }
const _hoisted_13 = {
  class: "sui-card sdash__todo",
  "data-tour": "seller-dash-tasks"
}
const _hoisted_14 = { class: "sui-card__head" }
const _hoisted_15 = { class: "sui-card__title" }
const _hoisted_16 = { class: "sui-card__body sdash__todo-body" }
const _hoisted_17 = { class: "sdash__todo-grid" }
const _hoisted_18 = { class: "sdash__task-icon" }
const _hoisted_19 = { class: "sdash__task-label" }
const _hoisted_20 = {
  key: 0,
  class: "sdash__task-hint"
}
const _hoisted_21 = {
  class: "sui-card sdash__trend",
  "data-tour": "seller-dash-stats"
}
const _hoisted_22 = { class: "sui-card__head" }
const _hoisted_23 = { class: "sdash__range" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "sui-card__body sdash__trend-body" }
const _hoisted_26 = { class: "sdash__trend-sum" }
const _hoisted_27 = { class: "sdash__sum-value" }
const _hoisted_28 = { class: "sdash__sum-value" }
const _hoisted_29 = { class: "sdash__sum-value" }
const _hoisted_30 = { class: "sdash__sum-value" }
const _hoisted_31 = { class: "sdash__trend-chart" }
const _hoisted_32 = {
  class: "sui-card sdash__status",
  "data-tour": "seller-dash-status"
}
const _hoisted_33 = { class: "sui-card__head" }
const _hoisted_34 = { class: "sui-card__body" }
const _hoisted_35 = {
  class: "sui-card sdash__top",
  "data-tour": "seller-dash-top"
}
const _hoisted_36 = { class: "sui-card__head" }
const _hoisted_37 = { class: "sui-card__body" }
const _hoisted_38 = { class: "sdash__rank" }
const _hoisted_39 = { class: "sdash__rank-no" }
const _hoisted_40 = ["src", "alt"]
const _hoisted_41 = { class: "sdash__rank-body" }
const _hoisted_42 = { class: "sdash__rank-name" }
const _hoisted_43 = { class: "sdash__rank-bar" }
const _hoisted_44 = { class: "sdash__rank-num" }
const _hoisted_45 = {
  key: 0,
  class: "sui-empty"
}
const _hoisted_46 = {
  class: "sui-card sdash__stock",
  "data-tour": "seller-dash-stock"
}
const _hoisted_47 = { class: "sui-card__head" }
const _hoisted_48 = { class: "sui-card__body" }
const _hoisted_49 = {
  key: 0,
  class: "sdash__stock-list"
}
const _hoisted_50 = ["src", "alt"]
const _hoisted_51 = { class: "sdash__stock-body" }
const _hoisted_52 = { class: "sdash__stock-name" }
const _hoisted_53 = { class: "sdash__stock-sub" }
const _hoisted_54 = {
  key: 1,
  class: "sui-empty sdash__stock-empty"
}
const _hoisted_55 = {
  class: "sui-card sdash__payout",
  "data-tour": "seller-dash-payout"
}
const _hoisted_56 = { class: "sui-card__head" }
const _hoisted_57 = { class: "sui-card__body" }
const _hoisted_58 = { class: "sdash__payout-amount" }
const _hoisted_59 = { class: "sdash__payout-detail" }
const _hoisted_60 = { class: "is-minus" }
const _hoisted_61 = {
  class: "sui-card sdash__orders",
  "data-tour": "seller-dash-orders"
}
const _hoisted_62 = { class: "sui-card__head" }
const _hoisted_63 = {
  key: 0,
  class: "sui-table-wrap"
}
const _hoisted_64 = { class: "sui-table" }
const _hoisted_65 = { class: "sui-table__strong" }
const _hoisted_66 = { class: "sui-table__sub" }
const _hoisted_67 = { class: "sui-prod" }
const _hoisted_68 = ["src", "alt"]
const _hoisted_69 = { class: "sui-prod__name" }
const _hoisted_70 = { class: "sui-table__sub" }
const _hoisted_71 = { class: "is-num sui-table__strong" }
const _hoisted_72 = { class: "is-center" }
const _hoisted_73 = {
  key: 0,
  class: "sdash__manual-tag"
}
const _hoisted_74 = {
  key: 1,
  class: "sui-empty"
}
const _hoisted_75 = {
  class: "sui-card sdash__reviews",
  "data-tour": "seller-dash-reviews"
}
const _hoisted_76 = { class: "sui-card__head" }
const _hoisted_77 = { class: "sui-card__title" }
const _hoisted_78 = { class: "sui-card__body" }
const _hoisted_79 = {
  key: 0,
  class: "sdash__review-list"
}
const _hoisted_80 = { class: "sdash__review-top" }
const _hoisted_81 = ["aria-label"]
const _hoisted_82 = { class: "sdash__review-date" }
const _hoisted_83 = { class: "sdash__review-text" }
const _hoisted_84 = { class: "sdash__review-prod" }
const _hoisted_85 = { class: "sdash__review-foot" }
const _hoisted_86 = { class: "sdash__review-who" }
const _hoisted_87 = {
  key: 0,
  class: "sdash__review-todo"
}
const _hoisted_88 = {
  key: 1,
  class: "sui-empty"
}

import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import SellerTrendChart from '@/components/seller/SellerTrendChart.vue'
import SellerDonutChart from '@/components/seller/SellerDonutChart.vue'
import {
  LOW_STOCK_THRESHOLD,
  SELLER_ORDER_STATUS_COLOR,
  SELLER_ORDER_STATUS_FLOW,
  SELLER_ORDER_STATUS_LABEL,
  SELLER_ORDER_STATUS_TONE,
  compactWon,
  formatWon,
  type SellerOrderStatus,
} from '@/constants/sellerData'
import {
  fetchSellerOrders,
  type ItemStatusCounts,
  type MallOrderItemStatus,
  type SellerOrderItem,
} from '@/api/mallOrder'
import { fetchSellerQnas, fetchSellerReviews, type SellerMallReview } from '@/api/mallReview'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { useSellerProducts } from '@/composables/useSellerProducts'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerDashboardPage',
  setup(__props) {

const { seller } = useSellerAuth()
const { products, loading: productsLoading, load: loadProducts } = useSellerProducts()

const storeName = computed(() => seller.value?.storeName || '판매업체')

const RANGES = [
  { days: 7, label: '7일' },
  { days: 30, label: '30일' },
  { days: 90, label: '90일' },
]

const range = ref(30)
const loading = ref(false)
const items = ref<SellerOrderItem[]>([])
const counts = ref<ItemStatusCounts>({})
const reviews = ref<SellerMallReview[]>([])
const openInquiryCount = ref(0)

const STATUS_MAP: Record<MallOrderItemStatus, SellerOrderStatus | null> = {
  WAITING: null,
  PAID: 'paid',
  READY: 'ready',
  SHIPPING: 'shipping',
  DELIVERED: 'delivered',
  DONE: 'delivered',
  CANCEL_REQUEST: 'cancelRequest',
  RETURN_REQUEST: 'returnRequest',
  CANCELED: 'cancelled',
}

function isDirectCourier(courier: string | undefined) {
  return /직접/.test(String(courier || ''))
}

const todayLabel = computed(() => {
  const now = new Date()
  const week = ['일', '월', '화', '수', '목', '금', '토'][now.getDay()]
  return `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일 (${week})`
})

function dayKey(value: string | null | undefined): string {
  if (!value) return ''
  return String(value).slice(0, 10)
}

function addDays(base: Date, days: number): Date {
  const next = new Date(base)
  next.setDate(next.getDate() + days)
  return next
}

function toYmd(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function activeItems(list: SellerOrderItem[]) {
  return list.filter((item) => item.status !== 'CANCELED')
}

function buildSeries(days: number) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const start = addDays(today, -(days - 1))
  const map = new Map<string, { date: string; revenue: number; orders: number }>()

  for (let i = 0; i < days; i += 1) {
    const key = toYmd(addDays(start, i))
    map.set(key, { date: key, revenue: 0, orders: 0 })
  }

  activeItems(items.value).forEach((item) => {
    const key = dayKey(item.paidAt || item.orderedAt)
    const bucket = map.get(key)
    if (!bucket) return
    bucket.revenue += item.amount
    bucket.orders += 1
  })

  return [...map.values()]
}

function sumSeries(series: { revenue: number; orders: number }[]) {
  return series.reduce(
    (acc, point) => ({
      revenue: acc.revenue + point.revenue,
      orders: acc.orders + point.orders,
    }),
    { revenue: 0, orders: 0 },
  )
}

async function load() {
  loading.value = true
  try {
    const [orderResult, reviewList, qnaList] = await Promise.all([
      fetchSellerOrders(),
      fetchSellerReviews().catch(() => [] as SellerMallReview[]),
      fetchSellerQnas().catch(() => []),
    ])
    items.value = orderResult.items
    counts.value = orderResult.counts
    reviews.value = reviewList
    openInquiryCount.value = qnaList.filter((item) => !item.answer).length
  } catch {
    items.value = []
    counts.value = {}
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  load()
  loadProducts()
})

const rangeSeries = computed(() => buildSeries(range.value))
const rangeTotal = computed(() => sumSeries(rangeSeries.value))
const avgOrderValue = computed(() =>
  rangeTotal.value.orders ? Math.round(rangeTotal.value.revenue / rangeTotal.value.orders) : 0,
)

const trendPoints = computed(() =>
  rangeSeries.value.map((point) => ({
    label: `${Number(point.date.slice(5, 7))}.${point.date.slice(8, 10)}`,
    value: point.revenue,
  })),
)

const todaySeries = computed(() => buildSeries(1)[0] ?? { revenue: 0, orders: 0 })
const yesterdaySeries = computed(() => {
  const two = buildSeries(2)
  return two[0] ?? { revenue: 0, orders: 0 }
})
const last7 = computed(() => sumSeries(buildSeries(7)))
const prev7 = computed(() => {
  const fourteen = buildSeries(14)
  return sumSeries(fourteen.slice(0, 7))
})

function rate(current: number, previous: number): number | null {
  if (!previous) return null
  return Math.round(((current - previous) / previous) * 100)
}

function deltaText(value: number | null, suffix: string): string {
  if (value === null) return '비교 기준 없음'
  const sign = value >= 0 ? '+' : ''
  return `${sign}${value}% ${suffix}`
}

const settlementPreview = computed(() => {
  const list = activeItems(items.value)
  const salesAmount = list.reduce((sum, item) => sum + item.amount, 0)
  const platform = list.reduce((sum, item) => sum + item.platformMargin, 0)
  const sellerMargin = list.reduce((sum, item) => sum + item.sellerMargin, 0)
  const payout = list.reduce((sum, item) => sum + item.settlement, 0)
  return { salesAmount, platform, sellerMargin, payout }
})

const directPendingCount = computed(
  () =>
    items.value.filter((item) => item.status === 'SHIPPING' && isDirectCourier(item.courier)).length,
)

const kpis = computed(() => {
  const todayRate = rate(todaySeries.value.revenue, yesterdaySeries.value.revenue)
  const orderRate = rate(todaySeries.value.orders, yesterdaySeries.value.orders)
  const weekRate = rate(last7.value.revenue, prev7.value.revenue)

  return [
    {
      label: '오늘 매출',
      value: formatWon(todaySeries.value.revenue),
      unit: '원',
      icon: 'mdi-cash-multiple',
      tone: 'blue',
      delta: todayRate,
      deltaText: deltaText(todayRate, '어제 대비'),
    },
    {
      label: '오늘 주문',
      value: formatWon(todaySeries.value.orders),
      unit: '건',
      icon: 'mdi-cart-outline',
      tone: 'violet',
      delta: orderRate,
      deltaText: deltaText(orderRate, '어제 대비'),
    },
    {
      label: '최근 7일 매출',
      value: formatWon(last7.value.revenue),
      unit: '원',
      icon: 'mdi-chart-line',
      tone: 'green',
      delta: weekRate,
      deltaText: deltaText(weekRate, '직전 7일 대비'),
    },
    {
      label: '정산 예정 금액',
      value: formatWon(settlementPreview.value.payout),
      unit: '원',
      icon: 'mdi-bank-outline',
      tone: 'amber',
      delta: null,
      deltaText: '결제 완료 주문 기준',
    },
  ]
})

function deltaClass(delta: number | null) {
  if (delta === null) return 'is-flat'
  return delta >= 0 ? 'is-up' : 'is-down'
}

function countMapped(status: SellerOrderStatus): number {
  if (status === 'paid') return counts.value.PAID ?? 0
  if (status === 'ready') return counts.value.READY ?? 0
  if (status === 'shipping') return counts.value.SHIPPING ?? 0
  if (status === 'delivered') return (counts.value.DELIVERED ?? 0) + (counts.value.DONE ?? 0)
  if (status === 'cancelRequest') return counts.value.CANCEL_REQUEST ?? 0
  if (status === 'returnRequest') return counts.value.RETURN_REQUEST ?? 0
  if (status === 'cancelled') return counts.value.CANCELED ?? 0
  return 0
}

const unansweredReviews = computed(() => reviews.value.filter((review) => !review.reply).length)

const tasks = computed(() => [
  {
    label: '신규 주문',
    count: countMapped('paid'),
    to: '/seller/orders?status=PAID',
    icon: 'mdi-cart-arrow-down',
    tone: 'blue',
    urgent: true,
    hint: '주문 확인 · 발송',
  },
  {
    label: '발송 대기',
    count: countMapped('ready'),
    to: '/seller/orders?status=READY',
    icon: 'mdi-package-variant-closed',
    tone: 'violet',
    urgent: true,
    hint: '송장 입력',
  },
  {
    label: '직접배송 완료',
    count: directPendingCount.value,
    to: '/seller/orders?status=SHIPPING',
    icon: 'mdi-hand-back-right-outline',
    tone: 'amber',
    urgent: true,
    hint: '수동 「배송완료」',
  },
  {
    label: '취소 요청',
    count: countMapped('cancelRequest'),
    to: '/seller/claims',
    icon: 'mdi-close-circle-outline',
    tone: 'red',
    urgent: true,
    hint: '승인 · 반려',
  },
  {
    label: '반품 요청',
    count: countMapped('returnRequest'),
    to: '/seller/claims',
    icon: 'mdi-package-variant-remove',
    tone: 'red',
    urgent: true,
    hint: '승인 · 반려',
  },
  {
    label: '미답변 문의',
    count: openInquiryCount.value,
    to: '/seller/reviews?tab=inquiry',
    icon: 'mdi-message-question-outline',
    tone: 'green',
    urgent: false,
    hint: '고객 문의',
  },
  {
    label: '답변 대기 후기',
    count: unansweredReviews.value,
    to: '/seller/reviews',
    icon: 'mdi-star-outline',
    tone: 'green',
    urgent: false,
    hint: '후기 답글',
  },
])

const taskTotal = computed(() => tasks.value.reduce((sum, task) => sum + task.count, 0))

const statusSlices = computed(() =>
  SELLER_ORDER_STATUS_FLOW.map((status) => ({
    label: SELLER_ORDER_STATUS_LABEL[status],
    value: countMapped(status),
    color: SELLER_ORDER_STATUS_COLOR[status],
  })).filter((slice) => slice.value > 0),
)

function statusBadge(status: SellerOrderStatus): string {
  return SELLER_ORDER_STATUS_TONE[status]
}

const topProducts = computed(() => {
  const since = toYmd(addDays(new Date(), -29))
  const map = new Map<string, { code: string; name: string; image: string; revenue: number; qty: number }>()

  activeItems(items.value).forEach((item) => {
    const key = dayKey(item.paidAt || item.orderedAt)
    if (!key || key < since) return
    const code = item.productCode || item.name
    const row = map.get(code) ?? {
      code,
      name: item.name,
      image: item.image,
      revenue: 0,
      qty: 0,
    }
    row.revenue += item.amount
    row.qty += item.qty
    map.set(code, row)
  })

  return [...map.values()].sort((a, b) => b.revenue - a.revenue).slice(0, 5)
})

const topRevenue = computed(() => topProducts.value[0]?.revenue || 1)

const stockWatch = computed(() =>
  [...products.value].sort((a, b) => a.stock - b.stock || b.soldCount - a.soldCount).slice(0, 5),
)

function stockBadgeClass(stock: number): string {
  if (stock <= 0) return 'sui-badge--red'
  if (stock <= LOW_STOCK_THRESHOLD) return 'sui-badge--amber'
  return 'sui-badge--gray'
}

const recentOrders = computed(() =>
  items.value.slice(0, 6).map((item) => {
    const directShip = isDirectCourier(item.courier)
    return {
      id: item.orderCode,
      orderedAt: item.paidAt || item.orderedAt,
      productName: item.name,
      productImage: item.image,
      buyerOrg: item.buyerOrg,
      qty: item.qty,
      amount: item.amount,
      status: STATUS_MAP[item.status] || 'paid',
      directShip,
      needsManualDone: item.status === 'SHIPPING' && directShip,
    }
  }),
)

const recentReviews = computed(() => reviews.value.slice(0, 4))
const avgRating = computed(() => {
  if (!reviews.value.length) return '0.0'
  const sum = reviews.value.reduce((acc, review) => acc + review.rating, 0)
  return (sum / reviews.value.length).toFixed(1)
})

function formatDateTime(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return `${date.getMonth() + 1}.${date.getDate()} ${String(date.getHours()).padStart(2, '0')}:${String(
    date.getMinutes(),
  ).padStart(2, '0')}`
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(todayLabel.value), 1),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(storeName.value) + " 판매 현황 ", 1),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" 오늘 매출 " + _toDisplayString(_unref(formatWon)(todaySeries.value.revenue)) + "원 · 주문 " + _toDisplayString(todaySeries.value.orders) + "건 ", 1),
          (taskTotal.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · 처리할 일 " + _toDisplayString(taskTotal.value) + "건", 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/seller/orders?status=PAID",
          class: "sui-btn sui-btn--primary"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createTextVNode(" 신규 주문 ", -1)),
            (countMapped('paid'))
              ? (_openBlock(), _createElementBlock("em", _hoisted_8, _toDisplayString(countMapped('paid')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/seller/orders?status=READY",
          class: "sui-btn"
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createTextVNode(" 발송 대기 ", -1)),
            (countMapped('ready'))
              ? (_openBlock(), _createElementBlock("em", _hoisted_9, _toDisplayString(countMapped('ready')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/seller/products?form=new",
          class: "sui-btn"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("상품 등록", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("aside", {
      class: _normalizeClass(["sdash__notice", { 'is-urgent': directPendingCount.value > 0 }]),
      "data-tour": "seller-dash-direct"
    }, [
      _createElementVNode("span", _hoisted_10, [
        _createVNode(AppIcon, {
          icon: "mdi-truck-delivery-outline",
          size: 22
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sdash__notice-body" }, [
        _createElementVNode("p", { class: "sdash__notice-title" }, "직접배송은 「배송완료」를 직접 눌러 주세요"),
        _createElementVNode("p", { class: "sdash__notice-text" }, [
          _createTextVNode(" 택배 송장은 도착이 조회되면 자동으로 배송완료됩니다. 직접배송은 자동 조회가 없어, "),
          _createElementVNode("strong", null, "상품이 도착한 뒤 주문 관리에서 「배송완료」를 수동으로 눌러야"),
          _createTextVNode(" 정산에 반영됩니다. ")
        ])
      ], -1)),
      (directPendingCount.value > 0)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/seller/orders?status=SHIPPING",
            class: "sdash__notice-cta"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 대기 " + _toDisplayString(directPendingCount.value) + "건 ", 1),
              _createVNode(AppIcon, {
                icon: "mdi-chevron-right",
                size: 16
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: "/seller/orders?status=SHIPPING",
            class: "sdash__notice-cta is-quiet"
          }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createTextVNode(" 배송중 확인 ", -1)),
              _createVNode(AppIcon, {
                icon: "mdi-chevron-right",
                size: 16
              })
            ]),
            _: 1
          }))
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpis.value, (kpi) => {
      return (_openBlock(), _createElementBlock("article", {
        key: kpi.label,
        class: "sui-card sdash__kpi"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["sdash__kpi-icon", `sdash__kpi-icon--${kpi.tone}`])
        }, [
          _createVNode(AppIcon, {
            icon: kpi.icon,
            size: 20
          }, null, 8, ["icon"])
        ], 2),
        _createElementVNode("p", _hoisted_11, _toDisplayString(kpi.label), 1),
        _createElementVNode("p", _hoisted_12, [
          _createTextVNode(_toDisplayString(kpi.value), 1),
          _createElementVNode("em", null, _toDisplayString(kpi.unit), 1)
        ]),
        _createElementVNode("p", {
          class: _normalizeClass(["sdash__kpi-delta", deltaClass(kpi.delta)])
        }, [
          (kpi.delta !== null)
            ? (_openBlock(), _createBlock(AppIcon, {
                key: 0,
                icon: kpi.delta >= 0 ? 'mdi-trending-up' : 'mdi-trending-down',
                size: 15
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(kpi.deltaText), 1)
        ], 2)
      ]))
    }), 128)),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h2", _hoisted_15, [
          _cache[5] || (_cache[5] = _createTextVNode(" 바로 처리할 일 ", -1)),
          _createElementVNode("em", null, _toDisplayString(taskTotal.value) + "건", 1)
        ]),
        _createVNode(_component_router_link, {
          to: "/seller/orders",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createTextVNode(" 주문 관리 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: task.label,
              to: task.to,
              class: _normalizeClass(["sdash__task", [`is-${task.tone}`, { 'is-hot': task.count > 0 && task.urgent }]])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_18, [
                  _createVNode(AppIcon, {
                    icon: task.icon,
                    size: 18
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["sdash__task-count", { 'is-zero': !task.count }])
                }, _toDisplayString(task.count), 3),
                _createElementVNode("span", _hoisted_19, _toDisplayString(task.label), 1),
                (task.hint)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(task.hint), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "sui-card__title" }, [
          _createTextVNode(" 매출 추이 "),
          _createElementVNode("em", null, "취소 · 반품 제외")
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(RANGES, (option) => {
            return _createElementVNode("button", {
              key: option.days,
              type: "button",
              class: _normalizeClass(["sdash__range-btn", { 'is-active': range.value === option.days }]),
              onClick: ($event: any) => (range.value = option.days)
            }, _toDisplayString(option.label), 11, _hoisted_24)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "sdash__sum-label" }, "기간 매출", -1)),
            _createElementVNode("p", _hoisted_27, [
              _createTextVNode(_toDisplayString(_unref(formatWon)(rangeTotal.value.revenue)), 1),
              _cache[8] || (_cache[8] = _createElementVNode("em", null, "원", -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "sdash__sum-label" }, "주문 건수", -1)),
            _createElementVNode("p", _hoisted_28, [
              _createTextVNode(_toDisplayString(_unref(formatWon)(rangeTotal.value.orders)), 1),
              _cache[10] || (_cache[10] = _createElementVNode("em", null, "건", -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "sdash__sum-label" }, "건당 평균", -1)),
            _createElementVNode("p", _hoisted_29, [
              _createTextVNode(_toDisplayString(_unref(formatWon)(avgOrderValue.value)), 1),
              _cache[12] || (_cache[12] = _createElementVNode("em", null, "원", -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "sdash__sum-label" }, "일 평균", -1)),
            _createElementVNode("p", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(formatWon)(Math.round(rangeTotal.value.revenue / range.value))), 1),
              _cache[14] || (_cache[14] = _createElementVNode("em", null, "원", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(SellerTrendChart, {
            points: trendPoints.value,
            "aria-label": "일별 매출 추이"
          }, null, 8, ["points"])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "sui-card__title" }, [
          _createTextVNode("주문 상태 "),
          _createElementVNode("em", null, "최근 90일")
        ], -1)),
        _createVNode(_component_router_link, {
          to: "/seller/orders",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[16] || (_cache[16] = _createTextVNode(" 전체 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(SellerDonutChart, {
          slices: statusSlices.value,
          "center-label": "총 주문",
          "aria-label": "주문 상태 분포"
        }, null, 8, ["slices"])
      ])
    ]),
    _createElementVNode("section", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "sui-card__title" }, [
          _createTextVNode("잘 팔리는 상품 "),
          _createElementVNode("em", null, "최근 30일")
        ], -1)),
        _createVNode(_component_router_link, {
          to: "/seller/products",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[18] || (_cache[18] = _createTextVNode(" 상품 관리 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("ol", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topProducts.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.code
            }, [
              _createVNode(_component_router_link, {
                to: `/seller/products/${item.code}`,
                class: "sdash__rank-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(index + 1), 1),
                  (item.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "sdash__rank-img",
                        src: item.image,
                        alt: item.name,
                        loading: "lazy"
                      }, null, 8, _hoisted_40))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_41, [
                    _createElementVNode("span", _hoisted_42, _toDisplayString(item.name), 1),
                    _createElementVNode("span", _hoisted_43, [
                      _createElementVNode("em", {
                        style: _normalizeStyle({ width: `${(item.revenue / topRevenue.value) * 100}%` })
                      }, null, 4)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_44, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(compactWon)(item.revenue)) + "원", 1),
                    _createElementVNode("em", null, _toDisplayString(item.qty) + "개", 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        (!topProducts.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createVNode(AppIcon, {
                icon: "mdi-package-variant",
                size: 28
              }),
              _cache[20] || (_cache[20] = _createElementVNode("p", null, "최근 30일 판매 데이터가 없습니다.", -1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "sui-card__title" }, [
          _createTextVNode("재고 확인 "),
          _createElementVNode("em", null, "적은 순")
        ], -1)),
        _createVNode(_component_router_link, {
          to: "/seller/products?stock=low",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[21] || (_cache[21] = _createTextVNode(" 전체 재고 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_48, [
        (stockWatch.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_49, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockWatch.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.code
                }, [
                  _createVNode(_component_router_link, {
                    class: "sdash__stock-link",
                    to: `/seller/products?stock=low&code=${encodeURIComponent(item.code)}`
                  }, {
                    default: _withCtx(() => [
                      (item.thumbnail)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "sdash__stock-img",
                            src: item.thumbnail,
                            alt: item.name,
                            loading: "lazy"
                          }, null, 8, _hoisted_50))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_51, [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(item.name), 1),
                        _createElementVNode("span", _hoisted_53, "누적 판매 " + _toDisplayString(item.soldCount) + "개", 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-badge", stockBadgeClass(item.stock)])
                      }, _toDisplayString(item.stock === 0 ? '품절' : `${item.stock}개 남음`), 3)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createVNode(AppIcon, {
                icon: "mdi-package-variant",
                size: 30
              }),
              _createElementVNode("p", null, _toDisplayString(_unref(productsLoading) ? '불러오는 중…' : '등록된 상품이 없습니다.'), 1)
            ]))
      ])
    ]),
    _createElementVNode("section", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "sui-card__title" }, "정산 예정", -1)),
        _createVNode(_component_router_link, {
          to: "/seller/settlements",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[23] || (_cache[23] = _createTextVNode(" 정산 관리 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("p", _hoisted_58, [
          _createTextVNode(_toDisplayString(_unref(formatWon)(settlementPreview.value.payout)), 1),
          _cache[25] || (_cache[25] = _createElementVNode("em", null, "원", -1))
        ]),
        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "sdash__payout-date" }, "결제 완료된 주문 기준 · 정산 예정액", -1)),
        _createElementVNode("dl", _hoisted_59, [
          _createElementVNode("div", null, [
            _cache[26] || (_cache[26] = _createElementVNode("dt", null, "판매 금액", -1)),
            _createElementVNode("dd", null, _toDisplayString(_unref(formatWon)(settlementPreview.value.salesAmount)) + "원", 1)
          ]),
          _createElementVNode("div", null, [
            _cache[27] || (_cache[27] = _createElementVNode("dt", null, "수수료", -1)),
            _createElementVNode("dd", _hoisted_60, "-" + _toDisplayString(_unref(formatWon)(settlementPreview.value.platform)) + "원", 1)
          ]),
          _createElementVNode("div", null, [
            _cache[28] || (_cache[28] = _createElementVNode("dt", null, "판매업체 마진", -1)),
            _createElementVNode("dd", null, "+" + _toDisplayString(_unref(formatWon)(settlementPreview.value.sellerMargin)) + "원", 1)
          ]),
          _createElementVNode("div", null, [
            _cache[29] || (_cache[29] = _createElementVNode("dt", null, "정산 예정 (원가+마진)", -1)),
            _createElementVNode("dd", null, _toDisplayString(_unref(formatWon)(settlementPreview.value.payout)) + "원", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _cache[32] || (_cache[32] = _createElementVNode("h2", { class: "sui-card__title" }, "최근 주문", -1)),
        _createVNode(_component_router_link, {
          to: "/seller/orders",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[31] || (_cache[31] = _createTextVNode(" 전체 보기 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      (recentOrders.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createElementVNode("table", _hoisted_64, [
              _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "주문번호 · 일시"),
                  _createElementVNode("th", null, "상품"),
                  _createElementVNode("th", { class: "is-num" }, "금액"),
                  _createElementVNode("th", { class: "is-center" }, "상태")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentOrders.value, (order) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${order.id}-${order.productName}`
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_65, _toDisplayString(order.id), 1),
                      _createElementVNode("span", _hoisted_66, _toDisplayString(formatDateTime(order.orderedAt)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_67, [
                        (order.productImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "sui-prod__img",
                              src: order.productImage,
                              alt: order.productName,
                              loading: "lazy"
                            }, null, 8, _hoisted_68))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, [
                          _createElementVNode("span", _hoisted_69, _toDisplayString(order.productName), 1),
                          _createElementVNode("span", _hoisted_70, [
                            _createTextVNode(_toDisplayString(order.buyerOrg) + " · " + _toDisplayString(order.qty) + "개 ", 1),
                            (order.directShip)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · 직접배송")
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_71, _toDisplayString(_unref(formatWon)(order.amount)) + "원", 1),
                    _createElementVNode("td", _hoisted_72, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-badge", statusBadge(order.status)])
                      }, _toDisplayString(_unref(SELLER_ORDER_STATUS_LABEL)[order.status]), 3),
                      (order.needsManualDone)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_73, "수동 완료 필요"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_74, [
            _createVNode(AppIcon, {
              icon: "mdi-cart-outline",
              size: 30
            }),
            _createElementVNode("p", null, _toDisplayString(loading.value ? '불러오는 중입니다…' : '결제 완료된 주문이 아직 없습니다.'), 1)
          ]))
    ]),
    _createElementVNode("section", _hoisted_75, [
      _createElementVNode("div", _hoisted_76, [
        _createElementVNode("h2", _hoisted_77, [
          _cache[34] || (_cache[34] = _createTextVNode(" 최근 리뷰 ", -1)),
          _createElementVNode("em", null, "평균 " + _toDisplayString(avgRating.value) + "점 · 답변 대기 " + _toDisplayString(unansweredReviews.value) + "건", 1)
        ]),
        _createVNode(_component_router_link, {
          to: "/seller/reviews?tab=review",
          class: "sui-card__link"
        }, {
          default: _withCtx(() => [
            _cache[35] || (_cache[35] = _createTextVNode(" 전체 보기 ", -1)),
            _createVNode(AppIcon, {
              icon: "mdi-chevron-right",
              size: 15
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_78, [
        (recentReviews.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_79, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentReviews.value, (review) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: review.id
                }, [
                  _createVNode(_component_router_link, {
                    class: "sdash__review",
                    to: `/seller/reviews?tab=review&productCode=${encodeURIComponent(review.productCode)}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_80, [
                        _createElementVNode("span", {
                          class: "sdash__stars",
                          "aria-label": `${review.rating}점`
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                            return _createVNode(AppIcon, {
                              key: star,
                              icon: star <= review.rating ? 'mdi-star' : 'mdi-star-outline',
                              size: 14
                            }, null, 8, ["icon"])
                          }), 64))
                        ], 8, _hoisted_81),
                        _createElementVNode("span", _hoisted_82, _toDisplayString(review.date), 1)
                      ]),
                      _createElementVNode("p", _hoisted_83, _toDisplayString(review.content), 1),
                      _createElementVNode("p", _hoisted_84, _toDisplayString(review.productName), 1),
                      _createElementVNode("p", _hoisted_85, [
                        _createElementVNode("span", _hoisted_86, _toDisplayString(review.author) + " · " + _toDisplayString(review.org), 1),
                        (!review.reply)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                              _createVNode(AppIcon, {
                                icon: "mdi-reply",
                                size: 13
                              }),
                              _cache[36] || (_cache[36] = _createTextVNode(" 답변 대기 ", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_88, [
              _createVNode(AppIcon, {
                icon: "mdi-comment-outline",
                size: 28
              }),
              _cache[37] || (_cache[37] = _createElementVNode("p", null, "아직 등록된 후기가 없습니다.", -1))
            ]))
      ])
    ])
  ]))
}
}

})